export const GET_ALL_TRIP = `
query GetAllTrip(
  $input: TtripMWhereInput
  $skip: Float
  $take: Float
) {
    getTripM(where: $input, skip: $skip, take: $take, orderBy:{ createDate: DESC }){
        pageInfo {
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items {
            id
            name
            useYn
            plantId
            createId
            createDate
            modifyDate
            modifyId
        }
    }
}`;

export const CHECK_EXISTED_INDEX_NUM = `
query CheckExistedIndexNum($input:TtripDetailWhereInput!){
    getTripDetail(where:$input){
        items{
            tripId
            indexNum
        }
    }
}`;

export const CREATE_TRIP_BY_PLANT_ID = `
mutation CreateTripByPlantId($input:TtripMInput!){
    createTripM(input:$input){
        id
        name
        plantId
        createDate
        createId
        modifyDate
        modifyId
    }
}`;

export const CREATE_TRIP_DETAIL = `
mutation CreateTripDetail($input:TtripDetailInput!){
    createTripDetail(input:$input){
        id
        indexNum
        routeId
        tripId
    }
}`;

export const CHECK_EXISTED_TRIP = `
query CheckExistedRouteInTrip($input:TtripDetailWhereInput!){
    getTripDetail(where:$input){
        items{
            id
            routeId
        }
    }
}`;
